import React from 'react';
import MenuIcon from '@material-ui/icons/MoreHoriz';

const MenuHorizontalIcon = (props) => <MenuIcon {...props} />;

export default MenuHorizontalIcon;
